function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 21 21 21 21 0 0 0"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon/sf-small/save/white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-1",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "20.5 20.5 0.5 20.5 0.5 0.5 16.75 0.5 20.5 4.25"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-5",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mask-2)",
  points: "4.25 7.5 16.75 7.5 16.75 0.5 4.25 0.5"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  mask: "url(#mask-2)",
  cx: 11,
  cy: 14,
  r: 3
})));

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.8ccc4767.svg";
export { ForwardRef as ReactComponent };